<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="inputs.id ? `/scope/${inputs.id}` : `/scope`"
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>
                {{ $t("accreditation_area") }}
              </label>
              <app-input
                type="select"
                v-model="inputs.accreditation_area_id"
                :list="area"
                :required="true"
                v-on:change="onChangeArea"
                :disabled="inputs.id != null || inputs.parent_id != null"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>
                {{ $t("activity") }}
              </label>
              <app-input
                type="select"
                v-model="inputs.accreditation_activity_id"
                :list="activity"
                :required="true"
                :disabled="inputs.id != null || inputs.parent_id != null"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Nombre</label>
              <app-input
                type="text"
                v-model="inputs.value"
                placeholder="Ingrese el nombre del nodo"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../apiURL";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    modalTitle: String,
    editModalTitle: String,
    inputs: Object,
  },
  data() {
    return {
      preloader: false,
      modalId: "modal-add-edit",
      activity: [{ id: "", value: this.$t("select_option") }],
    };
  },
  computed: {
    title() {
      return this.inputs.id ? this.editModalTitle : this.modalTitle;
    },
    area() {
      let list = [];
      if (
        this.$store.state.accreditation.accAppOptions.accreditationAreas
          .length > 0
      ) {
        list = [
          { id: "", value: this.$t("select_option") },
          ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
        ];
      }
      return list;
    },
  },
  created() {
    this.onChangeArea();
  },
  methods: {
    submit() {
      if (!this.inputs.value) {
        this.$toastr.e("Debe llenar los campos obligatorios");
      } else {
        let url = actions.SCOPES;
        if (this.inputs.id) {
          url += `/${this.inputs.id}`;
          this.axiosPut({ url, data: this.inputs }).then((res) => {
            if (res.status == 200) {
              this.$store.dispatch("updateNode", this.inputs);
              this.$toastr.s(this.$t("updated_success"));
            } else {
              this.$toastr.s(res.data.message);
            }
          });
        } else {
          this.axiosPost({ url, data: this.inputs }).then((res) => {
            if (res.status == 200) {
              this.$toastr.s(this.$t("created_success"));
              this.$store.dispatch("addChildren", {
                ...res.data.node,
                children: [],
              });
            } else {
              this.$toastr.s(res.data.message);
            }
          });
        }
        this.$emit("close-modal");
      }
    },

    onChangeArea() {
      if (
        this.$store.state.accreditation.accAppOptions.accreditationActivities
          .length > 0
      ) {
        this.activity = [
          { id: "", value: this.$t("select_option") },
          ...this.$store.state.accreditation.accAppOptions.accreditationActivities.filter(
            (element) => {
              return element.parent == this.inputs.accreditation_area_id;
            }
          ),
        ];
      }
    },
  },
};
</script>
